import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const WhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Mostrar el botón después de 2 segundos
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Mostrar tooltip después de 5 segundos si está visible
    if (isVisible) {
      const tooltipTimer = setTimeout(() => {
        setShowTooltip(true);
        // Ocultar tooltip después de 5 segundos
        setTimeout(() => {
          setShowTooltip(false);
        }, 5000);
      }, 3000);

      return () => clearTimeout(tooltipTimer);
    }
  }, [isVisible]);

  const handleWhatsAppClick = () => {
    const phoneNumber = "528112419864";
    const message = encodeURIComponent(
      "Hola, me gustaría agendar una cita en Cardiología del Norte. ¿Podrían ayudarme con la información disponible?"
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const closeTooltip = () => {
    setShowTooltip(false);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* WhatsApp Button */}
      <div 
        className={`fixed bottom-4 sm:bottom-6 right-4 sm:right-6 z-50 transition-all duration-500 transform ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}
      >
        <button
          onClick={handleWhatsAppClick}
          className="group relative bg-success hover:bg-success/90 text-white p-3 sm:p-4 rounded-full shadow-button hover:shadow-button-hover transition-all duration-300 hover:scale-110 animate-pulse hover:animate-none touch-manipulation"
          aria-label="Contactar por WhatsApp"
          style={{ minHeight: '44px', minWidth: '44px' }}
        >
          {/* WhatsApp Icon SVG */}
          <svg 
            className="w-6 h-6 sm:w-8 sm:h-8" 
            viewBox="0 0 24 24" 
            fill="currentColor"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.89 3.687"/>
          </svg>

          {/* Ripple effect */}
          <div className="absolute inset-0 rounded-full bg-success/40 opacity-30 animate-ping"></div>
        </button>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div 
          className={`fixed bottom-16 sm:bottom-24 right-4 sm:right-6 z-50 transition-all duration-300 transform ${
            showTooltip ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
          }`}
        >
          <div className="bg-surface shadow-card rounded-xl sm:rounded-2xl p-3 sm:p-4 max-w-xs sm:max-w-sm relative border border-border">
            {/* Close button */}
            <button
              onClick={closeTooltip}
              className="absolute -top-2 -right-2 bg-background hover:bg-surface rounded-full p-1 transition-colors duration-200 touch-manipulation"
              style={{ minHeight: '32px', minWidth: '32px' }}
            >
              <XMarkIcon className="h-3 w-3 sm:h-4 sm:w-4 text-text-secondary" />
            </button>

            {/* Content */}
            <div className="flex items-start space-x-2 sm:space-x-3">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-success" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.89 3.687"/>
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-primary text-xs sm:text-sm mb-1">
                  ¡Agenda tu cita!
                </h4>
                <p className="text-text-secondary text-xs leading-relaxed">
                  Contáctanos por WhatsApp para agendar tu consulta cardiológica de forma rápida y sencilla.
                </p>
                <div className="mt-2 flex items-center text-success">
                  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-success rounded-full mr-1 sm:mr-2 animate-pulse"></div>
                  <span className="text-xs font-medium">En línea ahora</span>
                </div>
              </div>
            </div>

            {/* Arrow pointing to button */}
            <div className="absolute bottom-0 right-6 sm:right-8 transform translate-y-full">
              <div className="w-0 h-0 border-l-[6px] sm:border-l-[8px] border-r-[6px] sm:border-r-[8px] border-t-[6px] sm:border-t-[8px] border-l-transparent border-r-transparent border-t-surface"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsApp;
